import React, { useContext, useEffect, useState } from "react";

// STORAGE
import FullPageExportContext from "../../../../store/fullPageExportContext";

// COMPONENTS
import Wrapper from "../../../../components/helpers/Wrapper";
import Tab from "../../../../components/ui/Tab";

// PAGES
import YoutubeAllVideosOrganic from "./YoutubeAllVideosOrganic";
import YoutubeAllVideosOverall from "./YoutubeAllVideosOverall";
import YoutubeAllVideosPaid from "./YoutubeAllVideosPaid";

// UTILS
import { IAEvent_Primary_Tab_Visit } from "../../../../utils/IAEvents";
import { COKE_COMPANY_ID, HALEON_COMPANY_ID, IMPRIVATA_COMPANY_ID } from "../../../../constants/constants";
import { useSelector } from "react-redux";

export default function YoutubeAllVideos({ videoDurationType, topCardData }) {
  const { setExportPageName } = useContext(FullPageExportContext);

  // console.log('videoDurationType', videoDurationType)


  // USER DATA
  const userData = useSelector((state) => state.userData.user);
  let companyID = userData?.company?.id ?? "";

  // const tabData = ["Overall", "Organic", "Paid"];
  let tabData = [];

  if (companyID === COKE_COMPANY_ID || companyID === HALEON_COMPANY_ID || companyID === IMPRIVATA_COMPANY_ID) {
    tabData = ["Overall"];
  } else {
    tabData = ["Overall", "Paid"];
  }
  const [selectedTab, setSelectedTab] = useState(tabData[0]);

  const handleCallback = (event) => {
    if (selectedTab !== event) {
      setSelectedTab(event);
    }
    IAEvent_Primary_Tab_Visit("Marketing Intelligence", "Video", "Youtube", event)
  };

  useEffect(() => {
    setExportPageName("Video Youtube " + selectedTab)
  }, [selectedTab])

  return (
    <Wrapper>
      <div className="grid grid_margin_bottom">
        <Tab
          varient={"secondary"}
          tabData={tabData}
          activeTab={selectedTab}
          handleCallback={(event) => handleCallback(event)}
        />
      </div>
      {/* {selectedTab === "Overall" && <YoutubeAllVideosOverall videoDurationType={videoDurationType} />} */}
      {/* {selectedTab === "Organic" && <YoutubeAllVideosOrganic videoDurationType={videoDurationType} />} */}
      {selectedTab.toLowerCase() === "overall" && <YoutubeAllVideosOrganic videoDurationType={videoDurationType} topCardData={topCardData} />}
      {selectedTab.toLowerCase() === "paid" && <YoutubeAllVideosPaid videoDurationType={videoDurationType} topCardData={topCardData} />}
    </Wrapper>
  );
}
